(ns iris.route-scroll
  (:require
   [iris.scroll.navigation :as navigation]
   [iris.scroll.restoration :as restoration]))

(def post-rendered-hash-handlers
  #{:hashtag
    :latest
    :posts
    :posts-cc
    :posts-eid
    :posts-header
    :posts-ip
    :thread
    :user})

(defonce suppressed-post-anchor-route-rev (atom nil))

(def post-owned-hash-scroll-priority
  ;; Iris treats post hashes as meaningful navigation targets, not just document
  ;; fragments. Default to the URL hash winning over browser-like history scroll:
  ;; returning to /t/abc#nick should take the user to nick. Switch this to
  ;; :history-scroll to make back/forward restore where the user last scrolled,
  ;; which is closer to normal browser and Clerk behavior.
  :post-anchor)

(def post-owned-hash-scroll-priorities
  #{:post-anchor :history-scroll})

(defn route-data [route-context]
  (or (:route route-context)
      route-context))

(defn route-url []
  (let [location (.-location js/window)]
    (str (.-pathname location) (.-search location) (.-hash location))))

(defn post-owned-anchor? [route]
  (boolean
   (and (seq (:anchor-params route))
        (contains? post-rendered-hash-handlers (:handler route)))))

(defn suppress-post-anchor-scroll! [route-rev]
  (reset! suppressed-post-anchor-route-rev route-rev))

(defn post-anchor-scroll-suppressed? [route-rev]
  (and (some? route-rev)
       (= route-rev @suppressed-post-anchor-route-rev)))

(defn history-scroll-priority? [priority]
  (= :history-scroll priority))

(defn restore-history-scroll-for-post-anchor? [priority post-owned-anchor? saved-scroll-top]
  (and post-owned-anchor?
       (some? saved-scroll-top)
       (history-scroll-priority? priority)))

(defn saved-scroll-top-for-navigation [priority post-owned-anchor? saved-scroll-top]
  (when-not (and post-owned-anchor?
                 (some? saved-scroll-top)
                 (= :post-anchor priority))
    saved-scroll-top))

(defn initialize! []
  (restoration/initialize!))

(defn begin-navigation! []
  (navigation/begin-navigation!))

(defn navigate-route! [route-context]
  (let [route (route-data route-context)
        route-rev (:route-rev route-context)
        saved-scroll-top (restoration/saved-scroll-top)
        post-owned-anchor? (post-owned-anchor? route)]
    (when (restore-history-scroll-for-post-anchor?
           post-owned-hash-scroll-priority
           post-owned-anchor?
           saved-scroll-top)
      (suppress-post-anchor-scroll! route-rev))
    (navigation/navigate-page!
     {:url (route-url)
      :saved-scroll-top (saved-scroll-top-for-navigation
                         post-owned-hash-scroll-priority
                         post-owned-anchor?
                         saved-scroll-top)
      :post-owned-anchor? post-owned-anchor?})
    (navigation/flush-deferred-scroll!)))

(defn after-render! []
  (navigation/after-render!))
